<template>
  <div>
    <!-- Status Dropdown (Admin Only) -->
    <div v-if="displayMode === 'status'" style="width:150px;  height : 30px; margin-left:8px; display:flex; justify-content:center; align-itemscenter" >
      <CustomDropdown
        v-if="isAdmin"
        id="status"
        :options="statusOptions"
        :value="item.status"
        :placeholder="'Select Status'"
        :disabled="!isAdmin"
        @change="onStatusChange($event)"
        :height="'30px'"
      />
    </div>

    <!-- Resigned/Termination Date -->
    <div v-if="displayMode === 'resignationDate'" class="resignation-date">
      <input
          v-if="item.status === 'Resigned'"
          type="date"
          class="resignation"
          v-model="item.resignationDate"
          @change="updateResignationDate($event, item)"
        />
      <span v-else>-</span>
      <span
        v-if="item.status === 'Resigned' && item.resignationDate"
        class="info-icon"
        @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false"
      >
        <i class="fa fa-info-circle" style="color:#5EC1A5"></i>
        <span v-if="showTooltip" class="tooltip">
          {{ tooltipText }}
        </span>
      </span>
    </div>

    <!-- Fallback for debugging -->
    <div v-if="displayMode !== 'status' && displayMode !== 'resignationDate'">
      <span>Invalid displayMode: {{ displayMode }}</span>
    </div>
  </div>
</template>

<script>
import firebase from "src/assets/config/firebase.js";
import swal from "sweetalert";
import CustomDropdown from 'src/components/UIComponents/CustomDropdown.vue';

export default {
  emits: ["status-change"],
  components: { CustomDropdown },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    displayMode: {
      type: String,
      default: "status",
      validator: (value) => ["status", "resignationDate"].includes(value),
    },
  },
  data() {
    return {
      showTooltip: false,
      statusOptions: ["Probation", "Permanent", "Resigned", "Terminated"],
    };
  },
  computed: {
    tooltipText() {
      if (this.item.status !== "Resigned" || !this.item.resignationDate)
        return "";
      const resignationDate = new Date(this.item.resignationDate);
      const daysToAdd = 
      this.item.previousStatus === "Probation" ? 15 : 30;
      const estimatedLastDay = new Date(resignationDate);
      estimatedLastDay.setDate(resignationDate.getDate() + daysToAdd);
      const formattedDate = estimatedLastDay.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      return `Estimated Last Day: ${formattedDate}`;
    },
  },
  methods: {
      onStatusChange(newStatus) {
      this.$emit("status-change", {
        employee: this.item,
        newStatus,
        oldStatus: this.item.status,
      });
    },
    async updateResignationDate(event, item) {
      try {
        item.resignationDate = event.target.value;

        await firebase.updateUserResignationDate(
          item.resignationDate,
          item.uid
        );

        swal("Success", "Resignation/Termination date updated", "success");
        this.$store.dispatch("fetchAllUsersRealTime");
      } catch (error) {
        console.error("Error updating resignation date:", error);
        swal("Error", "Failed to update resignation date", "error");
      }
    },
  },
};
</script>

<style scoped>
.resignation-date {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

}
.resignation {
  width: 150px;
  height: 30px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  color: #495057;
  padding: 5px 12px;
  line-height: 1em;
  font-size: 14px;
  outline: none;
}
.info-icon {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  position: absolute;
  bottom: 125%; /* show above icon */
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 999;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/userManagement/Status.vue